import { bidlClient } from 'src/utils/api'
import { tryQuery } from 'src/utils/queries'

const baseUri = '/api/aggregator'

export type CreateOrUpdateLocationRequest = {
  data: {
    companyId: number
    datasourceId: string
    sourceId: string
    sourceName?: string
    internalName?: string
    publicName?: string
    parentId?: string
    physicalAddressLine1?: string
    physicalAddressLine2?: string
    physicalLocality?: string
    physicalAdministrativeArea?: string
    physicalPostalCode?: string
    physicalCountryCode?: string
    latitude?: number
    longitude?: number
    integrationId?: string
    businessType?: BusinessType[]
    businessEmail?: string
    businessWebsite?: string
    businessFax?: string
    businessPhone?: string
    pushNotificationsHiddenAt?: string
    cashBidsHiddenAt?: string
    hidden?: boolean
    revision?: string
  }
  type: TenantLocationType
}

type GetLocationByIdRequest = {
  tenantId: string
  locationId: string
  companyId: number
}

export const GetLocationById = async ({
  tenantId,
  locationId,
  companyId,
}: GetLocationByIdRequest) => {
  return tryQuery(
    bidlClient.post(
      `${baseUri}/location/v1/GetLocationById`,
      {
        id: locationId,
        companyId: companyId,
      },
      {
        headers: {
          'X-Bushel-Tenant': tenantId,
        },
      }
    )
  )
}

export const CreateOrUpdateLocation = async (
  tenantId: string,
  params: CreateOrUpdateLocationRequest[]
) => {
  return tryQuery(
    bidlClient.post(
      `${baseUri}/location/v1/CreateOrUpdateLocations`,
      {
        locations: params,
      },
      {
        headers: {
          'X-Bushel-Tenant': tenantId,
        },
      }
    )
  )
}
